import Cropper from "@/lib/components/Cropper";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import {CropResponse, EditableGroup, SetThumbnailRequest, ThumbnailSize, UploadResponse} from "@/lib/types";
import {dataRetryPolicy, fetchBackend, fetchBackendNoContent} from "@/lib/backend";
import ErrorPage from "@/lib/pages/ErrorPage";
import SpinnerPage from "@/lib/pages/SpinnerPage";
import {useSession} from "@/lib/auth/auth";
import {BASE_URL} from "@/lib/constants";
import {useLocalSearchParams, useRouter} from "expo-router";

export default function GroupBannerEditor() {
    const {group_id} = useLocalSearchParams();
    const {session} = useSession();
    const router = useRouter();
    const queryClient = useQueryClient();

    const {data, isPending, error} = useQuery<EditableGroup>({
        queryKey: ['group', group_id, 'edit', session],
        queryFn: () => fetchBackend(`/group/${group_id}/edit`, "GET", session),
        retry: dataRetryPolicy,
    })

    if (error) {
        return <ErrorPage error={error}/>
    } else if (isPending || !data) {
        return <SpinnerPage/>
    }

    function onCrop(crop: CropResponse) {
        const payload: SetThumbnailRequest = {
            thumbnail_id: crop.thumbnail_id,
        };
        fetchBackendNoContent(`/group/${group_id}`, "PATCH", session, payload).then(async () => {
            await queryClient.invalidateQueries({queryKey: ['group', group_id, 'edit', session]});
            router.dismiss();
        }).catch((err) => {
            console.error("set thumbnail", err);
        });
    }

    function imageSource(): UploadResponse | undefined {
        if (data && data.banner_picture_id && data.original_banner_url) {
            return {
                image_url: BASE_URL + data.original_banner_url,
                picture_id: data.banner_picture_id,
            }
        }
    }

    return (
        <Cropper
            source={imageSource()}
            sizeType={ThumbnailSize.CARD}
            onCrop={onCrop}
        />
    );
}